import {
  getMergedPdfUrl,
  getMergedPdfMeta,
  clearMergedPdf,
} from "../utils/store";

export async function renderResult(
  root: HTMLElement,
  onRestart: () => void
): Promise<void> {
  const blobUrl = getMergedPdfUrl();
  const meta = getMergedPdfMeta();

  if (!blobUrl || !meta) {
    root.innerHTML = `
      <header class="app-header app-header--compact">
        <div class="app-header__inner">
          <h1 class="app-header__title">Merge PDF</h1>
        </div>
      </header>
      <main class="page">
        <section class="empty-state">
          <h2>No file to download</h2>
          <p>Your merge result has expired. Please go back and merge again.</p>
          <button class="btn-primary btn-large" data-action="restart">Back to Editor</button>
        </section>
      </main>
    `;
    root
      .querySelector<HTMLButtonElement>('[data-action="restart"]')!
      .addEventListener("click", onRestart);
    return;
  }

  const sizeMb = (meta.sizeBytes / 1024 / 1024).toFixed(2);

  root.innerHTML = `
    <header class="app-header">
      <div class="app-header__inner">
        <h1 class="app-header__title">Merge PDF</h1>
        <p class="app-header__subtitle">Light PDF Tools, Portable &amp; Fully Private</p>
      </div>
    </header>

    <main class="page">
      <section class="success-section">
        <div class="success-check">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#E8F5E9"/>
            <path d="M14 24L21 31L34 18" stroke="#2E7D32" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2 class="success-title">Merge Complete!</h2>
        <p class="success-desc">Your PDF has been merged successfully.</p>
      </section>

      <section class="file-info">
        <div class="file-info__row">
          <span class="file-info__label">File Name</span>
          <span class="file-info__value" title="${escapeAttr(meta.fileName)}">${escapeHtml(meta.fileName)}</span>
        </div>
        <div class="file-info__row">
          <span class="file-info__label">Source Files</span>
          <span class="file-info__value">${meta.sourceCount} PDFs</span>
        </div>
        <div class="file-info__row">
          <span class="file-info__label">Total Pages</span>
          <span class="file-info__value">${meta.pageCount} pages</span>
        </div>
        <div class="file-info__row">
          <span class="file-info__label">File Size</span>
          <span class="file-info__value">${sizeMb} MB</span>
        </div>
      </section>

      <div class="download-area">
        <a class="btn-primary btn-large download-btn"
           data-action="download"
           href="${blobUrl}"
           download="${escapeAttr(meta.fileName)}">
          Download ${escapeHtml(meta.fileName)}
        </a>
      </div>

      <div class="restart-area">
        <button class="btn-link" data-action="restart">Merge another PDF</button>
      </div>
    </main>
  `;

  root
    .querySelector<HTMLButtonElement>('[data-action="restart"]')!
    .addEventListener("click", () => {
      clearMergedPdf();
      onRestart();
    });
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => {
    switch (c) {
      case "&": return "&amp;";
      case "<": return "&lt;";
      case ">": return "&gt;";
      case '"': return "&quot;";
      case "'": return "&#39;";
      default: return c;
    }
  });
}

function escapeAttr(s: string): string {
  return escapeHtml(s);
}
